import { AuthGuard } from '@/modules/auth/router/auth.guard';

export default [
    {
        name: 'notifications-settings',
        path: '/notifications-settings',
        component: () => import(/* webpackChunkName: "alert" */ '@/modules/alert/views/NotificationSettings.vue'),
        meta: { title: 'Notifications Settings' },
        props: true,
        beforeEnter: AuthGuard,
    },
    {
        name: 'notifications-settings:create',
        path: '/notifications-settings/create',
        component: () => import(/* webpackChunkName: "alert" */ '@/modules/alert/views/ConfigureAlert.vue'),
        meta: { title: 'Create Alert', feature: 'alerts' },
        props: true,
        beforeEnter: AuthGuard,
    },
    {
        name: 'notifications-settings:edit',
        path: '/notifications-settings/:id',
        component: () => import(/* webpackChunkName: "alert" */ '@/modules/alert/views/ConfigureAlert.vue'),
        meta: { title: 'Update Alert', feature: 'alerts' },
        props: true,
        beforeEnter: AuthGuard,
    },
];
